declare var BASE_URL:string;
declare var STATIC_BASE_URL:string;

import '../styles/carrers.scss';

import { h, Component } from 'preact';
import Illustration from './illustration';

export default class Partners extends Component<any, any> {

    constructor() {
        super();
    }

    public render (props, state): any {

        return <div id="careers">
            <div class="mainWrp">
              <section class="body center">
                <h1>A Great Start</h1>
                <h2 class="content">
                  We are changing the future and making a difference. Join our incredible team with your talent and passion!
                </h2>
                <p class="center">We are constantly looking for creative and self-motivated individuals with the following abilities:</p>
                <ul class="cols">
                  <li>
                    <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_chatbots.png' } />
                    <h3>Chatbot Building</h3>
                  </li><li>
                    <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_research.png' } />
                    <h3>Market Research​</h3>
                  </li><li>
                    <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_creativedesign.png' } />
                    <h3>Creative Design​</h3>
                  </li><li>
                    <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_content-creation.png' } />
                    <h3>Content Creation​</h3>
                  </li><li>
                    <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_data-analytics.png' } />
                    <h3>Data Analytics</h3>
                  </li>
                </ul>
            </section>
          </div>
          <section class="full grey">
            <h2>Internship</h2>
            <p>
              Querlo's internship experience will give you the opportunity to dive into the AI world. You will get a real understanding of Artificial Intelligence and sharpen up your skills.</p>​
            <p>We look for smart, creative and efficient interns to join our deeply talented team. This is a unique opportunity to work on an exciting and booming industry.</p>
            <p>If interested, please send your resume and cover letter to <a href="mailto:career@querlo.com">career@querlo.com</a></p>
          </section>
          <section class="full">
            <h2>Our Core Values</h2>
            <p>We believe in being honest and innovative and that technology<br />is most powerful when it empowers everyone.​</p>
          </section>
          <div class="mainWrp">
            <section class="body center">
              <h2>Why Join us</h2>
              <p class="center">Working here means you will be part of something uniquely special. Our team is ready to tackle challenges and build AI products that impact businesses. Join us on our journey to solve industry challenges and create great conversational user experience.​</p>
              <ul class="cols">
                <li>
                  <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_talented-team.png' } />
                  <h3>Talented Team</h3>
                </li><li>
                <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_booming-industry.png' } />
                <h3>Booming Industry</h3>
              </li><li>
                <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_room-for-growth.png' } />
                <h3>Room for growth and challenging environment</h3>
              </li><li>
                <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_global-footprint.png' } />
                <h3>Global Footprint</h3>
              </li><li>
                <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_various-industry-solutions.png' } />
                <h3>Various industries solutions</h3>
              </li><li>
                <img alt="illustration" src={ STATIC_BASE_URL + 'images/public/icons/ico_clients.png' } />
                <h3>World renowned Clients and partners</h3>
              </li>
              </ul>
            </section>
          </div>
        </div>;
    }
}


// WEBPACK FOOTER //
// ./ts/Careers.tsx